/* eslint-disable @typescript-eslint/no-explicit-any */
// Funciones puras compartidas entre el modal de crear/editar versión
// (ModalService/ModalComponent) y file-manager, para validar y formatear los
// campos del formulario de versión de archivo sin duplicar lógica.

export function isValidDateString(value: string): boolean {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;
  const date = new Date(`${value}T00:00:00`);
  return !isNaN(date.getTime());
}

export function isValidMonthString(value: string): boolean {
  if (!/^\d{2}\/\d{4}$/.test(value)) return false;
  const [month, year] = value.split('/').map(Number);
  return month >= 1 && month <= 12 && year > 0;
}

export function isVersionDateInFuture(value: string): boolean {
  if (!isValidMonthString(value)) return false;
  const [month, year] = value.split('/').map(Number);
  const now = new Date();
  return year > now.getFullYear() || (year === now.getFullYear() && month > now.getMonth() + 1);
}

export function isExpirationBeforeVersionMonth(expirationDate: string, versionDate: string): boolean {
  if (!isValidMonthString(versionDate)) return false;
  const [month, year] = versionDate.split('/').map(Number);
  const versionStart = new Date(year, month - 1, 1);
  const expiration = new Date(`${expirationDate}T00:00:00`);
  return expiration < versionStart;
}

export function isValidItemName(name: string): boolean {
  // No permite punto al principio ni al final
  return /^[\p{L}\p{N} _\-.·']+$/u.test(name) && !name.startsWith('.') && !name.endsWith('.');
}

/** Formatea en vivo el input de fecha de versión (MM/YYYY) mientras se escribe. */
export function formatVersionDateInput(raw: string, isDeletion: boolean, hasSlash: boolean): string {
  const year = new Date().getFullYear();
  if (raw.length >= 2) {
    const month = Number.parseInt(raw.substring(0, 2), 10);
    if (month > 12) {
      raw = raw.substring(0, 1);
    } else if (month === 0) {
      raw = '01' + raw.substring(2);
    }
  }

  let formatted: string;
  if (raw.length === 0) {
    formatted = '';
  } else if (raw.length === 1) {
    const d = Number.parseInt(raw, 10);
    formatted = !isDeletion && d > 1 ? `0${raw}/` : raw;
  } else if (isDeletion && raw.length <= 2 && !hasSlash) {
    formatted = raw;
  } else {
    formatted = `${raw.substring(0, 2)}/${raw.substring(2)}`;
  }

  if (hasSlash && formatted.includes('/')) {
    const [m, y] = formatted.split('/');
    if (Number.parseInt(y, 10) > year) {
      formatted = `${m}/${year}`;
    }
  }

  return formatted;
}

/** Etiqueta visible de una versión: su nombre o, si no tiene, su número (01, 02...). */
export function getVersionLabelName(v: any): string {
  const name = v?.itemVersionName;
  if (name && name !== 'null') return String(name).trim();
  const num = Number(v?.itemVersion) || 0;
  return num ? String(num).padStart(2, '0') : '';
}

/** Busca una versión existente por nombre (o número). Devuelve null si es nueva. */
export function findExistingVersion(history: any[], name: string): any | null {
  const target = (name ?? '').toString().trim().toLowerCase();
  if (!target || !Array.isArray(history)) return null;
  return history.find((v) => getVersionLabelName(v).toLowerCase() === target) ?? null;
}
